__webpack_require__.p = "/veon_tech/";